"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageHelpLink = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var copy_1 = require("../../copy");
var UsageHelpLink_styled_1 = require("./UsageHelpLink.styled");
var UsageHelpLink = function () {
    var _a;
    var _b = (0, core_1.useComponents)(), P = _b.P, TextLink = _b.TextLink;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var usageEnergyUseHelp = (0, core_1.useLinks)().usageEnergyUseHelp;
    return (react_1.default.createElement(UsageHelpLink_styled_1.SmallScreenCentre, { as: P },
        react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.USAGE_HELP_LINK, properties: (_a = {}, _a[core_1.INTERNAL_EVENT_FLAG] = true, _a) },
            react_1.default.createElement(TextLink, { href: usageEnergyUseHelp() },
                react_1.default.createElement(Copy, { copyKey: "helpLinkBody" })))));
};
exports.UsageHelpLink = UsageHelpLink;
